export default __webpack_public_path__ + "static/media/Software-Gestao-Assiduidade.022cca6a.png";